import type { CustomCellRendererProps } from "ag-grid-react";
import i18n from "i18next";
import * as R from "ramda";
import k from "src/i18n/keys";
import type { UID } from "src/types";
import GroupName from "../GroupName";
import { GroupsContainer, GroupsInnerDiv } from "./styles";

interface GroupsCellRendererProps extends CustomCellRendererProps {
  data: { uid: UID };
}

export const GroupsCellRenderer = ({
  value: groups,
}: GroupsCellRendererProps): React.ReactElement => {
  return (
    <GroupsContainer>
      <GroupsInnerDiv>
        {R.take(3, groups || []).map((g: number) => (
          <GroupName key={g} id={g} />
        ))}
        {(groups || []).length > 3
          ? `    ${i18n.t(k._13)}${groups.length - 3}`
          : null}
      </GroupsInnerDiv>
    </GroupsContainer>
  );
};
